function customSelects() {
  $('.js-select-custom select').selectric({
    disableOnMobile: false,
    nativeOnMobile: false,
    onInit: function() {
      emptyOptions($(this))
    },
    onChange: function(element) {
      $(element).trigger('change');
      
      emptyOptions($(element))
    },
  });
}

// Empty Options
function emptyOptions(element) {
  const $optionSelected = element.find('option:selected');
  const $row = element.closest('.form__row-secondary');
  if ($row.length) {
    if ($optionSelected.val() != '') {
      $row.addClass('alt')
    } else {
      $row.removeClass('alt')
    }
  };
}

customSelects();

module.exports = {
  customSelects
};



// WEBPACK FOOTER //
// ../assets/js/custom-select.js